export default function ZeusJackpot({ show }) {
  if (!show) return null;
  return (
    <div className="zeus-overlay" aria-hidden="true">
      <div className="zeus-flash-bg" />
      <div className="zeus-bolt zeus-bolt-1" />
      <div className="zeus-bolt zeus-bolt-2" />
      <div className="zeus-bolt zeus-bolt-3" />
      <div className="zeus-text">⚡ ZEUS MURKA! JACKPOT! ⚡</div>
    </div>
  );
}
